import { useMutation } from '@tanstack/react-query'

import {
  AtualizarPessoaJuridica,
  type TUpdatePessoaJuridicaData,
} from '@/features/proposta/services/atualizar-pessoa-juridica.service'

export const useMutationAtualizarPessoaJuridica = () => {
  return useMutation({
    mutationFn: async (pessoaJuridica: TUpdatePessoaJuridicaData) => {
      const response = await new AtualizarPessoaJuridica().execute(pessoaJuridica)
      return response
    },
  })
}
